import React from 'react';
import { Tag } from 'antd';
import { StyledCheckableTag } from './KccCheckableTag.styles';

type CheckableTagProps = React.ComponentPropsWithoutRef<typeof Tag.CheckableTag>;

export interface KccCheckableTagProps extends CheckableTagProps {
  disabled?: boolean;
}

// Tag.CheckableTag has no built-in disabled prop/state (unlike Input, Select, Button, ...),
// so this wraps it with one, following the same disabled look used across the KCC theme.
export const KccCheckableTag = ({ disabled, onChange, ...rest }: KccCheckableTagProps): React.JSX.Element => (
  <StyledCheckableTag
    {...rest}
    $disabled={disabled}
    onChange={(checked): void => {
      if (disabled) {
        return;
      }
      onChange?.(checked);
    }}
  />
);
